(function () {
  interface LazyXfElement extends HTMLElement {
    dataset: {
      src: string;
      loaded?: string;
      strategy?: 'onload' | 'onclick' | 'onview';
    };
  }

  const stripGridWrapper = (frag: DocumentFragment): void => {
    const topContainer = Array.from(frag.children).find(
      (n) => n instanceof HTMLElement && n.classList.contains('container')
    ) as HTMLElement | undefined;

    if (!topContainer) return;

    const grid = Array.from(topContainer.children).find(
      (n) =>
        n instanceof HTMLElement &&
        n.classList.contains('root') &&
        n.classList.contains('container') &&
        n.classList.contains('responsivegrid')
    ) as HTMLElement | undefined;

    if (!grid) return;

    while (grid.firstChild) topContainer.insertBefore(grid.firstChild, grid);
    grid.remove();
  };

  const load = (el: LazyXfElement): void => {
    if (el.dataset.loaded) return;
    el.dataset.loaded = 'true';

    fetch(el.dataset.src)
      .then((r) => r.text())
      .then((html) => {
        const tpl = document.createElement('template');
        tpl.innerHTML = html.trim();

        tpl.content.querySelectorAll('meta, link[rel="stylesheet"], script').forEach((node) => {
          node.remove();
        });

        stripGridWrapper(tpl.content);
        el.replaceWith(tpl.content);
      })
      .catch(console.error);
  };

  const init = (): void => {
    document.querySelectorAll<LazyXfElement>('[data-lazy-xf]').forEach((el) => {
      switch (el.dataset.strategy || 'onload') {
        case 'onclick':
          el.addEventListener('click', () => load(el), { once: true, capture: true });
          break;
        case 'onview':
          new IntersectionObserver(
            (e, o) => {
              if (e[0].isIntersecting) {
                load(el);
                o.disconnect();
              }
            },
            { rootMargin: '200px' }
          ).observe(el);
          break;
        default:
          window.addEventListener('load', () => load(el), { once: true });
      }
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();
})();
export {};
